import { useRef } from 'react';
import { Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';

import { AttachedFilesPermissions } from '../../../../MonthlyServiceRequest/RequestDetailTypes';
import LineRowApprovalPending from '../LineRowApprovalPending/LineRowApprovalPending';
import './DailyWorkReportApproval.scss';
import { ubicationTypeEnum } from '../../../../../utils/dataStatus';
import { useWorkReportModals } from '../../../../../context/WorkReportModalsContext';

const DailyWorkReportApproval = (props) => {
  const {
    contract,
    providerOrUbication,
    requestLevel,
    service,
    fetchData,
    selectedDate,
    selectedInput,
    showApproveButton,
    showEditButton,
    showImputationObjectButton,
    showRejectButton,
    permissions,
    showPPButton,
    setHasError
  } = props;
  const { activeImputationApprovalModal } = useWorkReportModals();

  const formRef = useRef(null);

  return (
    <div className="work-report-body-container">
      {requestLevel.map(
        ({
          agrupadoPor: request,
          items: partesTrabajoDiario,
          tipoImputacion,
          objetoImputacion,
          idUbicacion
        }) => (
          <>
            <h5>
              <div className="sub-header-container">
                {' '}
                {providerOrUbication} - {service} - {contract} - {request}
                {showImputationObjectButton && (
                  <button
                    onClick={() => {
                      activeImputationApprovalModal({
                        data: partesTrabajoDiario[0],
                        detailsApproval: {
                          ...partesTrabajoDiario[0],
                          ubicacionId: idUbicacion,
                          tipoUbicacionEnum: partesTrabajoDiario[0]?.tipoUbicacionEnum
                        },

                        onEdit: fetchData,
                        setHasError,
                        form: formRef,
                        tpyeAndObjectImputationPermissions: permissions
                      });
                    }}
                    style={{
                      color: '#0063bd',
                      fontWeight: 'bold',
                      fontSize: '16px',
                      marginLeft: '12px',
                      cursor: 'pointer',
                      minWidth: '230px'
                    }}
                    type="button"
                  >
                    <span>
                      {partesTrabajoDiario[0]?.tipoUbicacionEnum === ubicationTypeEnum.locacion ? (
                        'VER DETALLES'
                      ) : (
                        <>
                          {tipoImputacion}
                          <br />
                          {objetoImputacion}
                        </>
                      )}
                    </span>
                  </button>
                )}
              </div>
            </h5>
            <Row className="header-line-table-approval">
              <Col className="gy-0" sm={3}>
                Posición
              </Col>
              <Col sm={3}>Línea</Col>
              <Col sm={1}>UM</Col>
              <Col sm={2}>Cantidad</Col>
              <Col sm={1}> </Col>
              {showPPButton &&
                (partesTrabajoDiario[0].tipoUbicacionEnum === ubicationTypeEnum.pozo ||
                  partesTrabajoDiario[0].tipoUbicacionEnum === ubicationTypeEnum.locacion) && (
                  <>
                    <Col sm={1} style={{ textAlign: 'left', padding: '3px' }}>
                      <span style={{ padding: '0px' }}>P.Prog</span>
                      <span style={{ marginLeft: '10px' }}>Cod.</span>
                    </Col>
                  </>
                )}
            </Row>
            {partesTrabajoDiario?.map((dailyWorkReport) => (
              <LineRowApprovalPending
                cantidad={dailyWorkReport?.cantidad}
                dailyWorkReport={dailyWorkReport}
                fetchData={fetchData}
                idUbicacion={idUbicacion}
                key={dailyWorkReport?.idParteDiario}
                lineaSap={dailyWorkReport?.lineaSap}
                permissions={permissions}
                posicionSap={dailyWorkReport?.posicionSap}
                selectedDate={selectedDate}
                selectedInput={selectedInput}
                showApproveButton={showApproveButton}
                showEditButton={showEditButton}
                showPPButton={showPPButton}
                showRejectButton={showRejectButton}
                unidadMedida={dailyWorkReport?.unidadMedida}
              />
            ))}
          </>
        )
      )}
    </div>
  );
};

export default DailyWorkReportApproval;

DailyWorkReportApproval.propTypes = {
  contract: PropTypes.string.isRequired,
  providerOrUbication: PropTypes.string.isRequired,
  requestLevel: PropTypes.arrayOf().isRequired,
  service: PropTypes.string.isRequired,
  fetchData: PropTypes.func.isRequired,
  selectedDate: PropTypes.string.isRequired,
  selectedInput: PropTypes.string.isRequired,
  showApproveButton: PropTypes.bool.isRequired,
  showEditButton: PropTypes.bool.isRequired,
  showImputationObjectButton: PropTypes.bool,
  showRejectButton: PropTypes.bool.isRequired,
  permissions: AttachedFilesPermissions,
  showPPButton: PropTypes.bool.isRequired,
  setHasError: PropTypes.func
};

DailyWorkReportApproval.defaultProps = {
  permissions: {
    visualize: false,
    write: false
  },
  showImputationObjectButton: true,
  setHasError: () => {}
};
